import { render, staticRenderFns } from "./DownloadButtons.vue?vue&type=template&id=a654b960&scoped=true&lang=pug&"
import script from "./DownloadButtons.vue?vue&type=script&lang=js&"
export * from "./DownloadButtons.vue?vue&type=script&lang=js&"
import style0 from "./DownloadButtons.vue?vue&type=style&index=0&id=a654b960&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a654b960",
  null
  
)

export default component.exports